import { Input } from '../../../../common/html/input'
import { CONTRACTION_FIELD_KEYS } from './constants'

export const InputField = ({ item, isValid, form, onChange, otherProps }) => {
  const getTextInvalid = (key) => {
    let textInvalid = ''
    if (key === CONTRACTION_FIELD_KEYS.PHONE) {
      textInvalid = 'domesticSearchPreview.INVALID_PHONE'
    }

    if (key === CONTRACTION_FIELD_KEYS.EMAIL) {
      textInvalid = 'domesticSearchPreview.INVALID_EMAIL'
    }

    return typeof form[key] === 'string' && !!form[key].trim()
      ? textInvalid
      : 'userProfile.REQUIRED_FIELD'
  }

  return (
    <Input
      noControl
      isShowIcon={false}
      placeHolder={item.title}
      isShowLabel
      isValid={isValid[item.key]}
      textInvalid={getTextInvalid(item.key)}
      onChange={(e) => onChange(item.key, e, item.isRequired)}
      value={form[item.key] || ''}
      style={{ height: 30 }}
      {...otherProps}
    />
  )
}
